import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { BehaviorSubject, catchError, EMPTY } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { YoutubeVideoService } from './youtube-video-service/youtube-video.service';

export type YouTubeVideoPlayerOptions = Pick<
  YT.PlayerOptions,
  'playerVars' | 'videoId'
> & { title: string };

@Component({
  selector: 'ui-youtube-video-modal',
  templateUrl: './youtube-video-modal.component.html',
  styleUrls: ['./youtube-video-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class YouTubeVideoModalComponent {
  private _hasNoError = new BehaviorSubject<boolean>(true);

  public youTubeApiScriptAdded$ = this._youtubeService
    .addYouTubeApiToDom()
    .pipe(catchError(() => EMPTY));
  public hasNoError$ = this._hasNoError.asObservable();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: YouTubeVideoPlayerOptions,
    private _dialogRef: MatDialogRef<YouTubeVideoModalComponent>,
    private _youtubeService: YoutubeVideoService,
  ) {}

  public closeModal(event: Event): void {
    event.preventDefault();

    this._dialogRef.close();
  }

  public onError(): void {
    this._hasNoError.next(false);
  }
}
